import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { resolveBackendOrigin } from '../utils/api'

const backendOrigin = resolveBackendOrigin()
const API_BASE_URL = `${backendOrigin}/api`

export default createStore({
  state: {
    token: null,
    user: null,
    loginSource: 'telegram',
    ready: false,
    startParam: null,
  },
  getters: {
    isAuthenticated(state) {
      return !!state.token
    },
    currentUser(state) {
      return state.user
    },
    loginSource(state) {
      return state.loginSource
    },
    isReady(state) {
      return state.ready
    },
    startParam(state) {
      return state.startParam
    },
  },
  mutations: {
    setAuth(state, { token, user, source }) {
      state.token = token
      state.user = user
      state.loginSource = source || state.loginSource || 'telegram'
    },
    setUser(state, user) {
      state.user = user
    },
    clearAuth(state) {
      state.token = null
      state.user = null
    },
    setReady(state, value) {
      state.ready = !!value
    },
    setStartParam(state, value) {
      state.startParam = value || null
    },
  },
  actions: {
    async loginWithTelegram({ commit }, payload) {
      const response = await fetch(`${API_BASE_URL}/auth/telegram`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
      const data = await response.json().catch(() => ({}))
      if (!response.ok) {
        throw new Error(data.message || 'Telegram authentication failed')
      }
      commit('setAuth', { token: data.token, user: data.user, source: 'telegram' })
      return data
    },

    async refreshToken({ commit, state }) {
      if (!state.token) return false
      try {
        const response = await fetch(`${API_BASE_URL}/auth/refresh`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
        if (!response.ok) throw new Error('Token refresh failed')
        const data = await response.json()
        commit('setAuth', { token: data.token, user: data.user })
        return true
      } catch (error) {
        console.error('Token refresh failed:', error)
        return false
      }
    },

    logout({ commit }) {
      commit('clearAuth')
      try {
        localStorage.removeItem('Ahun_last_activity')
      } catch {
        // ignore
      }
    },
  },
  plugins: [
    createPersistedState({
      key: 'Ahun_auth',
      paths: ['token', 'user', 'loginSource'],
      storage: window.localStorage,
    }),
  ],
})
